import React, { Fragment, useCallback, useEffect, useState } from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  Image,
  ScrollView,
  TextInput,
} from 'react-native';
import api from '../services/api';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

const Clientes = ({ route, navigation }) => {
  const [user, setUser] = useState(null);
  const [clientes, setClientes] = useState([]);
  const [clientesFiltrados, setClientesFiltrados] = useState([]);
  const [termoPesquisa, setTermoPesquisa] = useState('');
  const [loading, setLoading] = useState(true);

  const handleObterClientes = useCallback(async () => {
    setLoading(true);

    let user = localStorage.getItem('user');
    user = JSON.parse(user);
    setUser(user);

    const sorteio = route.params.sorteio;
    const { data } = await api.get(`sorteios/${sorteio.id}/clientes`);
    const clientesOrdenados = [...data].sort((a, b) =>
      a.nome.localeCompare(b.nome)
    );
    setClientes(clientesOrdenados);
    setClientesFiltrados(clientesOrdenados);
    setLoading(false);
  }, []);

  useEffect(() => {
    handleObterClientes();
  }, [handleObterClientes]);

  useEffect(() => {
    if (termoPesquisa.trim() === '') {
      setClientesFiltrados(clientes);
    } else {
      const filtrados = clientes.filter(
        (cliente) =>
          cliente.nome.toLowerCase().includes(termoPesquisa.toLowerCase()) ||
          cliente.whatsapp.includes(termoPesquisa)
      );
      setClientesFiltrados(filtrados);
    }
  }, [termoPesquisa, clientes]);

  const apagar = (cliente) => {
    const x = confirm('Deseja realmente apagar a venda?');
    if (x) {
      const sorteio = route.params.sorteio;
      const promises = cliente.cartelas.map((cartela) =>
        api.delete(`sorteios/${sorteio.id}/cancelar_venda/${cartela.id}`)
      );

      Promise.all(promises)
        .then(() => {
          alert('Venda cancelada com sucesso!');
          handleObterClientes();
        })
        .catch((e) => {
          if (e.response.data.msg) {
            alert(e.response.data.msg);
          } else {
            alert('Falha ao realizar venda');
          }
        });
    }
  };

  return (
    <View style={{ flex: 1 }}>
      <View style={{ margin: 20, flex: 1 }}>
        <View
          style={{
            backgroundColor: '#fff',
            padding: 10,
            marginTop: 10,
            borderRadius: 5,
            marginBottom: 10,
          }}
        >
          <Text style={{ fontSize: 12, marginBottom: 5 }}>
            Pesquisar cliente
          </Text>
          <TextInput
            style={{
              paddingTop: 5,
              paddingBottom: 5,
              paddingLeft: 5,
              borderWidth: 1,
              borderColor: '#000',
              borderRadius: 5,
            }}
            value={termoPesquisa}
            onChangeText={setTermoPesquisa}
            placeholder="Digite o nome ou WhatsApp do cliente"
          />
        </View>

        <ScrollView
          style={{ marginBottom: 15, paddingTop: 15, paddingBottom: 15 }}
        >
          {loading ? (
            <View
              style={{
                backgroundColor: '#fff',
                padding: 10,
                marginTop: 10,
                borderRadius: 5,
                alignItems: 'center',
              }}
            >
              <Image
                style={{ height: 32, width: 32 }}
                source={require('../assets/loading.gif')}
              />
            </View>
          ) : clientesFiltrados.length > 0 ? (
            clientesFiltrados.map((e) => (
              <View
                style={{
                  backgroundColor: '#fff',
                  padding: 10,
                  marginTop: 10,
                  borderRadius: 5,
                }}
              >
                <TouchableOpacity
                  onPress={() =>
                    navigation.navigate('ClientesCartelas', {
                      dados: e,
                      sorteioId: route.params.sorteio.id,
                      onRefresh: handleObterClientes,
                    })
                  }
                  style={{ flexDirection: 'row' }}
                >
                  <View style={{ flex: 1 }}>
                    <View>
                      <Text style={{ fontWeight: 'bold' }}>Cliente</Text>
                    </View>
                    <View>
                      <Text>{e.nome}</Text>
                    </View>
                  </View>
                  <View style={{ flex: 1 }}>
                    <View>
                      <Text style={{ fontWeight: 'bold' }}>Whatsapp</Text>
                    </View>
                    <View>
                      <Text>{e.whatsapp}</Text>
                    </View>
                  </View>
                  <View style={{ flex: 1 }}>
                    <View>
                      <Text style={{ fontWeight: 'bold' }}>Cartelas</Text>
                    </View>
                    <View>
                      <Text>{e._count?.cartelas ?? 0}</Text>
                    </View>
                  </View>
                </TouchableOpacity>

                {(user?.tipo == 'ADMIN' || user?.tipo == 'GERENTE') && (
                  <View style={{ marginTop: 10 }}>
                    <TouchableOpacity
                      style={{ flex: 1, marginRight: 5 }}
                      onPress={() => apagar(e)}
                    >
                      <Text
                        style={{
                          backgroundColor: '#e74c3c',
                          color: '#fff',
                          padding: 5,
                          borderRadius: 5,
                          textAlign: 'center',
                        }}
                      >
                        Apagar
                      </Text>
                    </TouchableOpacity>
                  </View>
                )}
              </View>
            ))
          ) : (
            <View
              style={{
                backgroundColor: '#fff',
                padding: 10,
                marginTop: 10,
                borderRadius: 5,
              }}
            >
              <Text style={{ textAlign: 'center' }}>
                {termoPesquisa.trim() === ''
                  ? 'Nenhum venda realizada'
                  : 'Nenhum cliente encontrado'}
              </Text>
            </View>
          )}
        </ScrollView>
      </View>
    </View>
  );
};

export default Clientes;
